(() => {
  const menuBtn = document.querySelector("[data-menu]");
  const mobile = document.querySelector("[data-mobile-nav]");
  if (menuBtn && mobile) {
    menuBtn.addEventListener("click", () => {
      const open = mobile.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    });
    mobile.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", () => {
        mobile.classList.remove("is-open");
        document.body.style.overflow = "";
      }),
    );
  }

  const nameInput = document.querySelector("[data-child-name]");
  const envelope = document.querySelector("[data-envelope-name]");
  const attrName = document.querySelector("#attr-child-name");
  const attrAge = document.querySelector("#attr-child-age");
  const attrNote = document.querySelector("#attr-gift-note");
  const ageInput = document.querySelector("#child-age");
  const noteInput = document.querySelector("#gift-note");
  if (nameInput && envelope) {
    const paint = () => {
      const v = nameInput.value.trim();
      envelope.textContent = v || "your explorer";
      if (attrName) attrName.value = v;
    };
    nameInput.addEventListener("input", paint);
    paint();
  }
  if (ageInput && attrAge) {
    attrAge.value = ageInput.value;
    ageInput.addEventListener("change", () => {
      attrAge.value = ageInput.value;
    });
  }
  if (noteInput && attrNote) {
    noteInput.addEventListener("input", () => {
      attrNote.value = noteInput.value.trim();
    });
  }

  document.querySelectorAll("[data-companions]").forEach((root) => {
    const buttons = root.querySelectorAll("[data-who]");
    const panel = root.querySelector("[data-who-copy]");
    const title = root.querySelector("[data-who-title]");
    const role = root.querySelector("[data-who-role]");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (title) title.textContent = btn.dataset.name || "";
        if (role) role.textContent = btn.dataset.role || "";
        if (panel) panel.textContent = btn.dataset.copy || "";
      });
    });
  });

  document.querySelectorAll(".reel-wrap").forEach((wrap) => {
    const reel = wrap.querySelector("[data-reel]");
    if (!reel) return;
    const step = () => Math.min(reel.clientWidth * 0.9, 640);
    wrap.querySelector(".reel-next")?.addEventListener("click", () => {
      reel.scrollBy({ left: step(), behavior: "smooth" });
    });
    wrap.querySelector(".reel-prev")?.addEventListener("click", () => {
      reel.scrollBy({ left: -step(), behavior: "smooth" });
    });
  });
})();
